import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { Control, Controller } from "react-hook-form";
import { CreateCalendarEventForm } from "app/services/api/types/calendar/requests/CreateCalendarEventForm";
import { FormControlledInput } from "ui/molecules/form/FormControlledInput";
import { SelectableOptionWithControl } from "../molecules/SelectableOptionWithControl";
import { CheckboxGroup } from "ui/gluestack/checkbox";
import {
  FormControl,
  FormControlError,
  FormControlErrorIcon,
  FormControlErrorText,
} from "ui/gluestack/form-control";
import { AlertCircleIcon } from "ui/gluestack/icon";
import { requiredValidation } from "ui/utils/Validators";
interface Props {
  control: Control<CreateCalendarEventForm>;
  isDisabled?: boolean;
}

export function DailyRecurrenceOptions({ control, isDisabled }: Props) {
  return (
    <Controller
      control={control}
      name="recurrence_rule.daily.option"
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        return (
          <FormControl isInvalid={!!error}>
            <CheckboxGroup
              value={value ? [value] : []}
              onChange={(val) => {
                onChange(val.length ? val[val.length - 1] : undefined);
              }}
              className="flex-col gap-4"
            >
              <SelectableOptionWithControl
                value="interval"
                controlElement={
                  <View className="flex-row items-center ">
                    <FormControlledInput
                      id="recurrence_rule.daily.interval"
                      name="recurrence_rule.daily.interval"
                      control={control}
                      placeholder="0"
                      className="flex-row items-center"
                      textInputClassName="flex-1 max-w-10"
                      isDisabled={value !== "interval" || isDisabled}
                      prefix={
                        <Text className="text-sm text-gray-600 mr-2">
                          Every
                        </Text>
                      }
                      postfix={
                        <Text className="text-sm text-gray-600 ml-2">
                          day(s)
                        </Text>
                      }
                      rules={{
                        validate: {
                          requiredIf: (fieldValue) => {
                            if (value === "interval" && !fieldValue) {
                              return "Interval is required";
                            }
                            return true;
                          },
                        },
                      }}
                    />
                  </View>
                }
              />

              <SelectableOptionWithControl
                value="weekday"
                label="Every weekday"
                className="ml-3"
              />
              <FormControlError>
                <FormControlErrorIcon
                  as={AlertCircleIcon}
                  className="text-error-500"
                  size="sm"
                />
                <FormControlErrorText className="text-error-500 text-sm">
                  {error?.message}
                </FormControlErrorText>
              </FormControlError>
            </CheckboxGroup>
          </FormControl>
        );
      }}
      rules={{
        required: requiredValidation("Daily Interval"),
      }}
    />
  );
}
